import React from 'react';
import PropTypes from 'prop-types';

import CancelBooking from './CancelBooking/CancelBooking';
import CancellationRequest from './CancellationRequest/CancellationRequest';
import translate from '../../../../../utils/translations';
import {TRIP_DETAILS} from '../../../../../utils/EDAP/ConversationDetails';
import {getCancellationInfo} from '../manageBookingUtils';

export const getIsCancellationRequested = (existingRequest) => {
    return (
        existingRequest.state === 'REQUESTED' ||
        existingRequest.state === 'REQUESTED_DAY' ||
        existingRequest.state === 'REQUESTED_WEEK'
    );
};

export const getIsCancellationRequestedOverDay = (existingRequest) => {
    return (
        existingRequest.state === 'REQUESTED_DAY' ||
        existingRequest.state === 'REQUESTED_WEEK'
    );
};

const Cancellation = (props) => {
    const {
        showCancellationRequest,
        showCancelBooking,
        showRefundInfoBtn,
        fetch,
    } = props;

    const renderCancellationRequest = () => {
        const {backUrl, conversationId, data, translations} = props;
        const existingRequest =
            data.getTravelerStay.stayState.stateOfStayData?.existingRequest ||
            {};
        const {actions, body, title} = existingRequest;
        const requestActions = actions || {};
        const isCancellationRequested =
            getIsCancellationRequested(existingRequest);
        const isCancellationRequestedOverDay =
            getIsCancellationRequestedOverDay(existingRequest);

        return (
            <CancellationRequest
                backUrl={backUrl}
                conversationId={conversationId}
                existingRequestTitle={title}
                existingRequestBody={body}
                isCancellationRequested={isCancellationRequested}
                isCancellationRequestedOverDay={isCancellationRequestedOverDay}
                requestActions={requestActions}
                showRefundInfoBtn={showRefundInfoBtn}
                translations={translations}
            />
        );
    };

    const renderCancelBooking = () => {
        const {
            conversationId,
            data,
            location,
            priceDetails,
            shortDisplayName,
            systemData,
            translations,
        } = props;
        const {
            getTravelerStay: {
                stayState: {
                    currentStateOfStay: {actions},
                    stateOfStayData,
                },
            },
        } = data;
        const allowedActions = actions?.map((action) => action.id) || [];
        const existingRequest = stateOfStayData?.existingRequest || {};
        const {fullLocale, locale} = systemData;
        const {label} = getCancellationInfo(allowedActions, translations);
        const isCancellationRequested =
            getIsCancellationRequested(existingRequest);
        const cancellationPolicyText = translate(
            translations,
            'trav-dash/trav-home',
            'messages',
            'th.inbox.conversation.quoteSummary.cancellationPolicy'
        );
        const cancelBookingText = translate(
            translations,
            'trav-dash/trav-home',
            'messages',
            'tripDetails.cancelBooking.title'
        );

        return (
            <CancelBooking
                actionLocation={TRIP_DETAILS}
                cancellationLabel={label}
                conversationId={conversationId}
                data={data}
                fetch={fetch}
                fullLocale={fullLocale}
                isFlexibleDates
                isCancellationRequested={isCancellationRequested}
                locale={locale}
                location={location}
                priceDetails={priceDetails}
                sectionTitle={
                    isCancellationRequested
                        ? cancellationPolicyText
                        : cancelBookingText
                }
                shortDisplayName={shortDisplayName}
                translations={translations}
            />
        );
    };

    return (
        <React.Fragment>
            {showCancellationRequest && renderCancellationRequest()}
            {showCancelBooking && renderCancelBooking()}
        </React.Fragment>
    );
};

export default Cancellation;

Cancellation.propTypes = {
    backUrl: PropTypes.string,
    conversationId: PropTypes.string,
    data: PropTypes.shape({}),
    fetch: PropTypes.func,
    location: PropTypes.string,
    priceDetails: PropTypes.shape({}),
    shortDisplayName: PropTypes.string,
    showCancelBooking: PropTypes.bool,
    showCancellationRequest: PropTypes.bool,
    showRefundInfoBtn: PropTypes.bool,
    systemData: PropTypes.shape({}),
    translations: PropTypes.shape({}),
};
